import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as myGlobals from 'src/app/globals';
import { HttpPaginationModel, HttpResponseModel } from 'src/app/models/response.model';
import { CreateLinksModel, PublicSharingsModel, UpdateLinksModel } from 'src/app/models/share-links.model';
import { MySharesModel, SharedToMeModel, SharesTransactionModel, TotalSharesModel } from 'src/app/models/shares.model';
import { StorageModel } from 'src/app/models/storage.model';
@Injectable({
  providedIn: 'root',
})
export class SharesService {
  constructor(private http: HttpClient) {}

  getMySharesListView(encryption: boolean, folderParams: HttpPaginationModel): Observable<HttpResponseModel<MySharesModel[]>> {
    let params: HttpParams = new HttpParams().set('encryptedStorageActive', encryption).set('size', folderParams.pageSize).set('page', folderParams.pageNumber);
    if (folderParams.sortField && folderParams.sortDirection) {
      params = params.set('sortField', folderParams.sortField).set('sortDirection', folderParams.sortDirection);
    }

    return this.http.get<HttpResponseModel<MySharesModel[]>>(`${myGlobals.Config.API}/shares/my-shares/list-view`, { params });
  }

  getMySharesGridView(encryption: boolean, directory: boolean, folderParams: HttpPaginationModel): Observable<HttpResponseModel<MySharesModel[]>> {
    let params: HttpParams = new HttpParams()
      .set('encryptedStorageActive', encryption ? 'true' : 'false')
      .set('directory', directory.toString())
      .set('size', folderParams.pageSize)
      .set('page', folderParams.pageNumber);

    if (folderParams.sortField && folderParams.sortDirection) {
      params = params.set('sortField', folderParams.sortField).set('sortDirection', folderParams.sortDirection);
    }

    return this.http.get<HttpResponseModel<MySharesModel[]>>(`${myGlobals.Config.API}/shares/my-shares/grid-view`, { params });
  }

  getSharedToMe(folderParams: HttpPaginationModel, encryption: boolean): Observable<HttpResponseModel<SharedToMeModel[]>> {
    let params: HttpParams = new HttpParams().set('size', folderParams.pageSize).set('page', folderParams.pageNumber);
    if (folderParams.sortField && folderParams.sortDirection) {
      params = params.set('sortField', folderParams.sortField).set('sortDirection', folderParams.sortDirection);
    }
    params = params.set('encryptedStorageActive', encryption);

    return this.http.get<HttpResponseModel<SharedToMeModel[]>>(`${myGlobals.Config.API}/shares/shared-with-me`, { params });
  }

  getSharedToMeGridView(folderParams: HttpPaginationModel, directory: boolean, encrypted?: boolean): Observable<HttpResponseModel<SharedToMeModel[]>> {
    let params: HttpParams = new HttpParams()
      .set('directory', directory.toString())
      .set('size', folderParams.pageSize)
      .set('page', folderParams.pageNumber)
      .set('encryptedStorageActive', !!encrypted);

    if (folderParams.sortField && folderParams.sortDirection) {
      params = params.set('sortField', folderParams.sortField).set('sortDirection', folderParams.sortDirection);
    }

    return this.http.get<HttpResponseModel<SharedToMeModel[]>>(`${myGlobals.Config.API}/shares/shared-with-me/grid-view`, { params });
  }

  createPublicShare(body: CreateLinksModel): Observable<string> {
    return this.http.post<string>(`${myGlobals.Config.API}/shares/public`, body);
  }

  updatePublicShare(body: UpdateLinksModel): Observable<any> {
    return this.http.put<any>(`${myGlobals.Config.API}/shares/public`, body);
  }

  getPublicSharings(objectId: string, folderParams?: HttpPaginationModel): Observable<HttpResponseModel<PublicSharingsModel[]>> {
    let params: HttpParams = new HttpParams();

    if (folderParams) {
      params = new HttpParams().set('size', folderParams.pageSize).set('page', folderParams.pageNumber);
    }

    return this.http.get<HttpResponseModel<PublicSharingsModel[]>>(`${myGlobals.Config.API}/shares/${objectId}/public`, { params });
  }

  getPrivateSharings(objectId: string, folderParams?: HttpPaginationModel): Observable<HttpResponseModel<PublicSharingsModel[]>> {
    let params: HttpParams = new HttpParams();

    if (folderParams) {
      params = new HttpParams().set('size', folderParams.pageSize).set('page', folderParams.pageNumber);
    }

    return this.http.get<HttpResponseModel<PublicSharingsModel[]>>(`${myGlobals.Config.API}/shares/${objectId}/private`, { params });
  }

  favoriteItem(items: TotalSharesModel[]): Observable<HttpResponseModel<void>> {
    const ids = items.map((item) => item.objectId);

    return this.http.put<HttpResponseModel<void>>(`${myGlobals.Config.API}/objects/bulk/favorite`, ids);
  }

  unfavoriteItem(items: TotalSharesModel[]): Observable<HttpResponseModel<void>> {
    const ids = items.map((item) => item.objectId);

    return this.http.put<HttpResponseModel<void>>(`${myGlobals.Config.API}/objects/bulk/unfavorite`, ids);
  }

  getObjectOfPrivateShares(privateShareId: string, shareInfoRequired: boolean, folderParams?: HttpPaginationModel): Observable<HttpResponseModel<StorageModel[]>> {
    let params: HttpParams = new HttpParams();
    if (folderParams) {
      params = params.set('size', folderParams.pageSize).set('page', folderParams.pageNumber);
      if (folderParams.sortField && folderParams.sortDirection) {
        params = params.set('sortField', folderParams.sortField).set('sortDirection', folderParams.sortDirection);
      }
    }
    if (shareInfoRequired) {
      params = params.set('shareInfoRequired', 'true');
    }

    return this.http.get<HttpResponseModel<StorageModel[]>>(`${myGlobals.Config.API}/objects/${privateShareId}`, { params });
  }

  getListObjectsOfSharedWithMeObject(objectId: string, folderParams?: HttpPaginationModel): Observable<HttpResponseModel<StorageModel[]>> {
    let params: HttpParams = new HttpParams();
    if (folderParams) {
      params = params.set('size', folderParams.pageSize).set('page', folderParams.pageNumber);
      if (folderParams.sortField && folderParams.sortDirection) {
        params = params.set('sortField', folderParams.sortField).set('sortDirection', folderParams.sortDirection);
      }
    }

    return this.http.get<HttpResponseModel<StorageModel[]>>(`${myGlobals.Config.API}/objects/shared-with-me/object/${objectId}`, { params });
  }

  //Shares inside gridview için kullanılacak
  getObjectOfPrivateSharesGridView(privateShareId: string, directory: boolean, folderParams?: HttpPaginationModel): Observable<HttpResponseModel<StorageModel[]>> {
    let params: HttpParams = new HttpParams();
    params = params.set('directory', directory.toString());
    if (folderParams) {
      params = params.set('size', folderParams.pageSize).set('page', folderParams.pageNumber);
      if (folderParams.sortField && folderParams.sortDirection) {
        params = params.set('sortField', folderParams.sortField).set('sortDirection', folderParams.sortDirection);
      }
    }

    return this.http.get<HttpResponseModel<StorageModel[]>>(`${myGlobals.Config.API}/objects/grid-view/${privateShareId}`, { params });
  }

  getListObjectsOfSharedWithMeObjectGridView(objectId: string, directory: boolean, folderParams?: HttpPaginationModel): Observable<HttpResponseModel<StorageModel[]>> {
    let params: HttpParams = new HttpParams();
    params = params.set('directory', directory.toString());
    if (folderParams) {
      params = params.set('size', folderParams.pageSize).set('page', folderParams.pageNumber);
      if (folderParams.sortField && folderParams.sortDirection) {
        params = params.set('sortField', folderParams.sortField).set('sortDirection', folderParams.sortDirection);
      }
    }

    return this.http.get<HttpResponseModel<StorageModel[]>>(`${myGlobals.Config.API}/objects/shared-with-me/object/grid-view/${objectId}`, { params });
  }

  getTransactionHistory(objectId: string, folderParams?: HttpPaginationModel): Observable<HttpResponseModel<SharesTransactionModel[]>> {
    let params: HttpParams = new HttpParams();
    params = new HttpParams().set('objectId', objectId);
    if (folderParams) {
      params = params.set('size', folderParams.pageSize).set('page', folderParams.pageNumber);
    }

    return this.http.get<HttpResponseModel<SharesTransactionModel[]>>(`${myGlobals.Config.API}/search/object-transaction-history`, { params });
  }

  getSharesHistory(paginationParams?: HttpPaginationModel): Observable<HttpResponseModel<SharesTransactionModel[]>> {
    let params: HttpParams = new HttpParams();

    if (paginationParams) {
      params = new HttpParams().set('page', paginationParams.pageNumber).set('size', paginationParams.pageSize);
    }

    return this.http.get<HttpResponseModel<SharesTransactionModel[]>>(`${myGlobals.Config.API}/search/user-share-actions`, { params });
  }

  cancelShares(privateShareIds: string[] = [], publicShareIds: string[] = []): Observable<any> {
    const body: { privateShareIds: string[]; publicShareIds: string[] } = {
      privateShareIds: [...privateShareIds],
      publicShareIds: [...publicShareIds],
    };

    return this.http.post<any>(`${myGlobals.Config.API}/shares/cancel`, { ...body });
  }

  leaveShares(privateShareIds: string[] = []): Observable<any> {
    const body: { privateShareIds: string[] } = {
      privateShareIds: [...privateShareIds],
    };

    return this.http.post<any>(`${myGlobals.Config.API}/shares/leave-private-share`, { ...body });
  }
}
